// components/GlobalOverlay.js
import React from 'react'
import { useGlobal } from '../context/GlobalContext'
import '../assets/css/Overlay.css'

function GlobalOverlay() {
  const { isLoading, message, messageType, hideMessage } = useGlobal()
  if (!isLoading && !message) {
    return null
  }
  return (
    <div className="overlay">
      {isLoading && (
        <div className="overlay-content">
          <div className="loader"></div>
        </div>
      )}
      {message && (
        <div className={`overlay-message ${messageType}`}>
          <p>{message}</p>
          <button onClick={hideMessage}>Close</button>
        </div>
      )}
    </div>
  )
}

export default GlobalOverlay